module.exports = __webpack_public_path__ + "img/18.2b577d6.png";